import { inject } from '@angular/core';
import { CanDeactivateFn, Router } from '@angular/router';
import { AuthService, LEAVE_WITHOUT_QUESTION } from '../services/auth.service';
import { ConfirmationService } from '../services/confirmation.service';
import { UNSAVED_CHANGES_CONFIRMATION } from '../services/unsaved-changes.service';

export interface PendingChangesAware {
  hasUnsavedChanges: () => boolean;
}

export const pendingChangesGuard: CanDeactivateFn<PendingChangesAware> = async (component, _route, currentState) => {
  if (!component?.hasUnsavedChanges) {
    return true;
  }

  if (!component.hasUnsavedChanges()) {
    return true;
  }

  // BE-1491: человек уже ответил «Уйти» на «Выход» или сам нажал «Войти» на плашке
  // «Сессия закончилась» — второй раз не спрашиваем. Метка едет с самим переходом.
  if (inject(Router).getCurrentNavigation()?.extras.info === LEAVE_WITHOUT_QUESTION) {
    return true;
  }

  const auth = inject(AuthService);
  const confirmationService = inject(ConfirmationService);
  // BE-1491: вопрос задан при конце сессии. «Остаться» — человек остаётся на форме уже без
  // сессии: на ней плашка «Сессия закончилась», и следующие 401 вопрос не повторяют.
  const sessionEnding = auth.endingSession;
  const leave = await confirmationService.confirm(UNSAVED_CHANGES_CONFIRMATION);
  if (!leave && sessionEnding) {
    auth.stayWithoutSession(currentState.url);
  }
  return leave;
};

